export const businessGroups = state => state.businessGroups
export const businessGroup = state => state.businessGroup